import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TExternalBatchDM from './TExternalBatchDM'
import TTradingPartnerDM from './TTradingPartnerDM'
import TAssetDM from './TAssetDM'
import TVehicleDM from './TVehicleDM'
import TResourceDM from './TResourceDM'
import ServicedDeviceCategory from './ServicedDeviceCategory'
import ServicedDeviceGroup from './ServicedDeviceGroup'
import TAddressDM from './TAddressDM'
import TOfficerDocumentDM from './TOfficerDocumentDM'
import ServicedDeviceType from './ServicedDeviceType'
import ServicedDeviceStatus from './ServicedDeviceStatus'
import TBatchDM from './TBatchDM'
import TRoutingVariantDM from './TRoutingVariantDM'
import TDeviceDocumentDM from './TDeviceDocumentDM'
import TArticleDM from './TArticleDM'
import TContactPersonDM from './TContactPersonDM'
import TArticleCodeDocumentDM from './TArticleCodeDocumentDM'
import TContractCodeDocumentDM from './TContractCodeDocumentDM'
import TCode6DocumentDM from './TCode6DocumentDM'
import TCode5DocumentDM from './TCode5DocumentDM'
import TCode4DocumentDM from './TCode4DocumentDM'
import TCode3DocumentDM from './TCode3DocumentDM'
import TCode2DocumentDM from './TCode2DocumentDM'
import TCode1DocumentDM from './TCode1DocumentDM'
import TCostCentreCollectionDocumentDM from './TCostCentreCollectionDocumentDM'
import TK2UserLookupDM from './TK2UserLookupDM'
import TTextDM from './TTextDM'
import TScheduledServiceOperationDM from './TScheduledServiceOperationDM'
import ServiceOperationType from './ServiceOperationType'
import TMarketingActivityTypeDM from './TMarketingActivityTypeDM'
import TWorkflowProcessDM from './TWorkflowProcessDM'
import TActivityDM from './TActivityDM'
import TCountryDM from './TCountryDM'
import TTownPartDM from './TTownPartDM'
import TTownDM from './TTownDM'
import TCommentDM from './TCommentDM'
import TServicedDeviceItemDM from './TServicedDeviceItemDM'
import TJobCardDM from './TJobCardDM'
import TPurchaseItemBookDM from './TPurchaseItemBookDM'
import TSalesItemBookDM from './TSalesItemBookDM'
import TServiceNoteDM from './TServiceNoteDM'
import TServiceContractDM from './TServiceContractDM'
import TSalesOrderDM from './TSalesOrderDM'
import TPurchaseOrderDM from './TPurchaseOrderDM'
import TServiceOperationDM from './TServiceOperationDM'
import TMaintenanceFrequencyDefinitionDM from './TMaintenanceFrequencyDefinitionDM'
import TAttributeValueDM from './TAttributeValueDM'
import TReleaseNoteDM from './TReleaseNoteDM'
import TExternalDocumentItemDM from './TExternalDocumentItemDM'
import TWorkflowProcessAsItemDM from './TWorkflowProcessAsItemDM'
import TLanguageMemoTranslationDM from './TLanguageMemoTranslationDM'
import TAttachedDocumentDM from './TAttachedDocumentDM'
import TOldNoteDM from './TOldNoteDM'

/**
 * Servisovaná zařízení
 */
export default class TServicedDeviceDM extends Data {
	public static className = 'TServicedDeviceDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'TimeStamp',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = true

	/**
	 * Označení partnera
	 */
	CustomerIdentification?: string

	/**
	 * Legislativně kontrolováno
	 */
	LegallyControlled?: string

	/**
	 * Zneplatněno
	 */
	IsInvalidRecord?: string

	/**
	 * Zařazení pro parametry
	 */
	ServiceParameterGroupId?: number

	/**
	 * Konec záruky
	 */
	WarrantyEndDate?: Date

	/**
	 * Datum uvedení do provozu
	 */
	LaunchDate?: Date

	/**
	 * Datum prodeje
	 */
	SalesDate?: Date

	/**
	 * Výrobní číslo
	 */
	ProductionNumber?: string

	/**
	 * Sériové číslo
	 */
	SerialNumber?: string

	/**
	 * Právo na záznam
	 */
	RightGroupId?: number

	/**
	 * Časové razítko
	 */
	TimeStamp?: string

	/**
	 * Změněno
	 */
	ChangedOn?: Date

	/**
	 * Vytvořeno
	 */
	CreatedOn?: Date

	/**
	 * Popis
	 */
	Description?: string

	/**
	 * Zkratka
	 */
	Abbr?: string

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Další servisní úkon
	 */
	NextOperationDateCalc?: Date

	/**
	 * Poslední nepotvrzený servisní úkon
	 */
	LastUnconfirmedOperationDateCalc?: Date

	/**
	 * Poslední potvrzený servisní úkon
	 */
	LastConfirmedOperationDateCalc?: Date

	/**
	 * Datum posledního úkonu dle typu
	 */
	LastConfirmedOperationDateByTypeCalc?: Date

	/**
	 * undefined
	 */
	TextHeaderMemoCalc?: string

	/**
	 * undefined
	 */
	TextFooterMemoCalc?: string

	/**
	 * Poslední komentář
	 */
	LastCommentParamCalc?: string

	/**
	 * Ulice (Adresa umístění)
	 */
	LocationAddressIdStreetCalc?: string

	/**
	 * Číslo orientační (Adresa umístění)
	 */
	LocationAddressIdOrientationNumberCalc?: string

	/**
	 * Číslo popisné (Adresa umístění)
	 */
	LocationAddressIdHouseNumberCalc?: string

	/**
	 * Název (Adresa umístění)
	 */
	LocationAddressIdNameCalc?: string

	/**
	 * PSČ (Adresa umístění)
	 */
	LocationAddressIdTownCodeCalc?: string

	/**
	 * Souřadnice (Adresa umístění)
	 */
	LocationAddressIdCoordinatesCalc?: string

	/**
	 * Právo na záznam
	 */
	RightGroupIdCalc?: number

	/**
	 * Externí šarže
	 */
	@Type(() => TExternalBatchDM)
	ExternalBatchId?: TExternalBatchDM

	/**
	 * Optimální dodavatel
	 */
	@Type(() => TTradingPartnerDM)
	OptimalSupplierId?: TTradingPartnerDM

	/**
	 * Karta majetku
	 */
	@Type(() => TAssetDM)
	AssetRID?: TAssetDM

	/**
	 * Zákazník pro fakturaci
	 */
	@Type(() => TTradingPartnerDM)
	CustomerForInvoicingId?: TTradingPartnerDM

	/**
	 * Vozidlo
	 */
	@Type(() => TVehicleDM)
	VehicleId?: TVehicleDM

	/**
	 * Zdroje
	 */
	@Type(() => TResourceDM)
	ResourceId?: TResourceDM

	/**
	 * Kategorie
	 */
	@Type(() => ServicedDeviceCategory)
	CategoryId?: ServicedDeviceCategory

	/**
	 * Skupina
	 */
	@Type(() => ServicedDeviceGroup)
	GroupId?: ServicedDeviceGroup

	/**
	 * Adresa umístění
	 */
	@Type(() => TAddressDM)
	LocationAddressId?: TAddressDM

	/**
	 * Zákazník umístění
	 */
	@Type(() => TTradingPartnerDM)
	CustomerLocationId?: TTradingPartnerDM

	/**
	 * Servisní pracovník
	 */
	@Type(() => TOfficerDocumentDM)
	ServiceWorkerId?: TOfficerDocumentDM

	/**
	 * Typ
	 */
	@Type(() => ServicedDeviceType)
	TypeId?: ServicedDeviceType

	/**
	 * Stav
	 */
	@Type(() => ServicedDeviceStatus)
	StatusId?: ServicedDeviceStatus

	/**
	 * Šarže
	 */
	@Type(() => TBatchDM)
	BatchId?: TBatchDM

	/**
	 * Varianta TP
	 */
	@Type(() => TRoutingVariantDM)
	RoutingVariantId?: TRoutingVariantDM

	/**
	 * Prostředek
	 */
	@Type(() => TDeviceDocumentDM)
	DeviceRID?: TDeviceDocumentDM

	/**
	 * Zboží
	 */
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM

	/**
	 * Zákazník
	 */
	@Type(() => TTradingPartnerDM)
	TradingPartnerId?: TTradingPartnerDM

	/**
	 * Kontaktní osoba
	 */
	@Type(() => TContactPersonDM)
	ContactPersonId?: TContactPersonDM

	/**
	 * Referent
	 */
	@Type(() => TOfficerDocumentDM)
	OfficerId?: TOfficerDocumentDM

	/**
	 * Kód zboží
	 */
	@Type(() => TArticleCodeDocumentDM)
	ArticleCodeId?: TArticleCodeDocumentDM

	/**
	 * Kód zakázky
	 */
	@Type(() => TContractCodeDocumentDM)
	ContractCodeRID?: TContractCodeDocumentDM

	/**
	 * Kód 6
	 */
	@Type(() => TCode6DocumentDM)
	Code6Id?: TCode6DocumentDM

	/**
	 * Kód 5
	 */
	@Type(() => TCode5DocumentDM)
	Code5Id?: TCode5DocumentDM

	/**
	 * Kód 4
	 */
	@Type(() => TCode4DocumentDM)
	Code4Id?: TCode4DocumentDM

	/**
	 * Kód 3
	 */
	@Type(() => TCode3DocumentDM)
	Code3Id?: TCode3DocumentDM

	/**
	 * Kód 2
	 */
	@Type(() => TCode2DocumentDM)
	Code2Id?: TCode2DocumentDM

	/**
	 * Kód 1
	 */
	@Type(() => TCode1DocumentDM)
	Code1Id?: TCode1DocumentDM

	/**
	 * Středisko
	 */
	@Type(() => TCostCentreCollectionDocumentDM)
	CostCentreId?: TCostCentreCollectionDocumentDM

	/**
	 * Změnil
	 */
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM

	/**
	 * Vytvořil
	 */
	@Type(() => TK2UserLookupDM)
	CreatedById?: TK2UserLookupDM

	/**
	 * Z
	 */
	@Type(() => TTextDM)
	InvalidRecordImgCalc?: TTextDM

	/**
	 * Poslední úkon dle typu
	 */
	@Type(() => TScheduledServiceOperationDM)
	LastConfirmedOperationRIDByTypeCalc?: TScheduledServiceOperationDM

	/**
	 * Typ servisního úkonu
	 */
	@Type(() => ServiceOperationType)
	ServiceTypeIdCalc?: ServiceOperationType

	/**
	 * D
	 */
	@Type(() => TTextDM)
	DocumentExistsCalc?: TTextDM

	/**
	 * undefined
	 */
	@Type(() => TMarketingActivityTypeDM)
	ActivityTypeRIDCalc?: TMarketingActivityTypeDM

	/**
	 * SP
	 */
	@Type(() => TTextDM)
	ProcessStateIdCalc?: TTextDM

	/**
	 * Aktuální proces
	 */
	@Type(() => TWorkflowProcessDM)
	CurrentProcessIdCalc?: TWorkflowProcessDM

	/**
	 * undefined
	 */
	@Type(() => TActivityDM)
	ActivityIdCalc?: TActivityDM

	/**
	 * Stát (Adresa umístění)
	 */
	@Type(() => TCountryDM)
	LocationAddressIdCountryIdCalc?: TCountryDM

	/**
	 * Část obce (Adresa umístění)
	 */
	@Type(() => TTownPartDM)
	LocationAddressIdTownPartIdCalc?: TTownPartDM

	/**
	 * Číslo (Adresa umístění)
	 */
	@Type(() => TTownDM)
	LocationAddressIdTownIdCalc?: TTownDM

	/**
	 * Komentáře
	 */
	@Type(() => TCommentDM)
	CommentChild?: TCommentDM[]

	/**
	 * Komponenty
	 */
	@Type(() => TServicedDeviceItemDM)
	ServicedDeviceItemChild?: TServicedDeviceItemDM[]

	/**
	 * undefined
	 */
	@Type(() => TJobCardDM)
	JobCardChild?: TJobCardDM[]

	/**
	 * undefined
	 */
	@Type(() => TPurchaseItemBookDM)
	PurchaseItemBookChild?: TPurchaseItemBookDM[]

	/**
	 * undefined
	 */
	@Type(() => TSalesItemBookDM)
	SalesItemBookChild?: TSalesItemBookDM[]

	/**
	 * undefined
	 */
	@Type(() => TServiceNoteDM)
	ServiceNoteChild?: TServiceNoteDM[]

	/**
	 * undefined
	 */
	@Type(() => TServiceContractDM)
	ServiceContractChild?: TServiceContractDM[]

	/**
	 * undefined
	 */
	@Type(() => TSalesOrderDM)
	SalesOrderChild?: TSalesOrderDM[]

	/**
	 * undefined
	 */
	@Type(() => TPurchaseOrderDM)
	PurchaseOrderChild?: TPurchaseOrderDM[]

	/**
	 * Servisní úkony - režim tabulka
	 */
	@Type(() => TServiceOperationDM)
	ServiceOperationChild?: TServiceOperationDM[]

	/**
	 * undefined
	 */
	@Type(() => TMaintenanceFrequencyDefinitionDM)
	MaintenanceFrequencyDefChild?: TMaintenanceFrequencyDefinitionDM[]

	/**
	 * undefined
	 */
	@Type(() => TScheduledServiceOperationDM)
	ScheduledServiceOperationChild?: TScheduledServiceOperationDM[]

	/**
	 * undefined
	 */
	@Type(() => TAttributeValueDM)
	AttributeValueChild?: TAttributeValueDM[]

	/**
	 * undefined
	 */
	@Type(() => TReleaseNoteDM)
	ReleaseNoteChild?: TReleaseNoteDM[]

	/**
	 * Seznam aktivit
	 */
	@Type(() => TActivityDM)
	ActivityChild?: TActivityDM[]

	/**
	 * Dokumenty
	 */
	@Type(() => TExternalDocumentItemDM)
	ExternalDocumentItemChild?: TExternalDocumentItemDM[]

	/**
	 * Procesy
	 */
	@Type(() => TWorkflowProcessAsItemDM)
	WorkflowProcessChild?: TWorkflowProcessAsItemDM[]

	/**
	 * Text hlavičky
	 */
	@Type(() => TLanguageMemoTranslationDM)
	TextHeaderChild?: TLanguageMemoTranslationDM[]

	/**
	 * Text patičky
	 */
	@Type(() => TLanguageMemoTranslationDM)
	TextFooterChild?: TLanguageMemoTranslationDM[]

	/**
	 * Svázané doklady
	 */
	@Type(() => TAttachedDocumentDM)
	AttachedDocumentOldChild?: TAttachedDocumentDM[]

	/**
	 * Poznámky
	 */
	@Type(() => TOldNoteDM)
	DeprecatedNoteOldChild?: TOldNoteDM[]

	/**
	 * Zneplatnění
	 */
	public BulkInvalidationCOMMAND() {
		return this.executeCommand('BulkInvalidationCOMMAND')
	}

	/**
	 * Zplatnění
	 */
	public BulkUnInvalidationCOMMAND() {
		return this.executeCommand('BulkUnInvalidationCOMMAND')
	}

	/**
	 * Zneplatnění/Zplatnění
	 */
	public InvalidationCOMMAND() {
		return this.executeCommand('InvalidationCOMMAND')
	}

	/**
	 * Režim zobrazení
	 */
	public SDSwapViewModeCOMMAND() {
		return this.executeCommand('SDSwapViewModeCOMMAND')
	}

	/**
	 * Potvrzení
	 */
	public BulkConfirmCOMMAND() {
		return this.executeCommand('BulkConfirmCOMMAND')
	}

	/**
	 * Odpotvrzení
	 */
	public BulkUnconfirmCOMMAND() {
		return this.executeCommand('BulkUnconfirmCOMMAND')
	}

	/**
	 * Změna data potvrzení
	 */
	public BulkChangeConfirmationDateCOMMAND(parameters: TBulkChangeConfirmationDateCOMMANDParams) {
		return this.executeCommand('BulkChangeConfirmationDateCOMMAND', parameters)
	}

	/**
	 * Storno
	 */
	public BulkCancelCOMMAND() {
		return this.executeCommand('BulkCancelCOMMAND')
	}

	/**
	 * Odstorno
	 */
	public BulkUnCancelCOMMAND() {
		return this.executeCommand('BulkUnCancelCOMMAND')
	}

	/**
	 * Potvrzení
	 */
	public ConfirmCOMMAND() {
		return this.executeCommand('ConfirmCOMMAND')
	}

	/**
	 * Odpotvrzení
	 */
	public UnconfirmCOMMAND() {
		return this.executeCommand('UnconfirmCOMMAND')
	}

	/**
	 * Změna data potvrzení
	 */
	public ChangeConfirmationDateCOMMAND(parameters: TChangeConfirmationDateCOMMANDParams) {
		return this.executeCommand('ChangeConfirmationDateCOMMAND', parameters)
	}

	/**
	 * Storno/Odstorno
	 */
	public CancelCOMMAND() {
		return this.executeCommand('CancelCOMMAND')
	}

	/**
	 * Zrušení stavu
	 */
	public ClearRecordStatusCOMMAND() {
		return this.executeCommand('ClearRecordStatusCOMMAND')
	}

	/**
	 * Změna stavu
	 */
	public ChangeRecordStatusCOMMAND() {
		return this.executeCommand('ChangeRecordStatusCOMMAND')
	}

	/**
	 * 
	 */
	public ChangeRecordStatusSWSCOMMAND(parameters: TChangeRecordStatusSWSCOMMANDParams) {
		return this.executeCommand('ChangeRecordStatusSWSCOMMAND', parameters)
	}

	/**
	 * Zrušení stavu
	 */
	public BulkClearRecordStatusCOMMAND() {
		return this.executeCommand('BulkClearRecordStatusCOMMAND')
	}

	/**
	 * Změna stavu
	 */
	public BulkChangeRecordStatusCOMMAND() {
		return this.executeCommand('BulkChangeRecordStatusCOMMAND')
	}

	/**
	 * Změna atributů
	 */
	public BulkChangeAttributesCOMMAND(parameters: TBulkChangeAttributesCOMMANDParams) {
		return this.executeCommand('BulkChangeAttributesCOMMAND', parameters)
	}

	/**
	 * Aktualizace sady atributů
	 */
	public BulkActualizeAttributesCOMMAND(parameters: TBulkActualizeAttributesCOMMANDParams) {
		return this.executeCommand('BulkActualizeAttributesCOMMAND', parameters)
	}

	/**
	 * Aktualizace sady atributů
	 */
	public ActualizeAttributesCOMMAND() {
		return this.executeCommand('ActualizeAttributesCOMMAND')
	}

	/**
	 * Změna skupiny práv
	 */
	public ChangeGroupRightCOMMAND() {
		return this.executeCommand('ChangeGroupRightCOMMAND')
	}

	/**
	 * Změna skupiny práv
	 */
	public BulkChangeGroupRightCOMMAND() {
		return this.executeCommand('BulkChangeGroupRightCOMMAND')
	}

	/**
	 * Aktualizace počítaných polí
	 */
	public BulkUpdateCalcFieldsCOMMAND() {
		return this.executeCommand('BulkUpdateCalcFieldsCOMMAND')
	}

	/**
	 * Kontrola legislativy
	 */
	public SwitchOffLegislationValidationCOMMAND() {
		return this.executeCommand('SwitchOffLegislationValidationCOMMAND')
	}
}

export type TBulkChangeConfirmationDateCOMMANDParams = {
	/**
	 * Datum potvrzení
	 */
	Confirmation1Date?: Date
	/**
	 * Hodina potvrzení
	 */
	Confirmation1Time?: Date
	/**
	 * Datum 2. potvrzení
	 */
	Confirmation2Date?: Date
	/**
	 * Hodina 2. potvrzení
	 */
	Confirmation2Time?: Date
	/**
	 * Kontrolovat záporné stavy
	 */
	CheckNegativeState?: boolean
	/**
	 * MessageText
	 */
	MessageText?: string
}

export type TChangeConfirmationDateCOMMANDParams = {
	/**
	 * Datum potvrzení
	 */
	Confirmation1Date?: Date
	/**
	 * Hodina potvrzení
	 */
	Confirmation1Time?: Date
	/**
	 * Datum 2. potvrzení
	 */
	Confirmation2Date?: Date
	/**
	 * Hodina 2. potvrzení
	 */
	Confirmation2Time?: Date
	/**
	 * Kontrolovat záporné stavy
	 */
	CheckNegativeState?: boolean
	/**
	 * MessageText
	 */
	MessageText?: string
}

export type TChangeRecordStatusSWSCOMMANDParams = {
	/**
	 * StatusId
	 */
	StatusId?: number
}

export type TBulkChangeAttributesCOMMANDParams = {
	/**
	 * Smazat atributy
	 */
	DeleteAttribute?: boolean
	/**
	 * Smazat všechny volné atributy
	 */
	DeleteFreeAttribute?: boolean
	/**
	 * Nastavit hodnoty atributů
	 */
	SetValues?: boolean
	/**
	 * Přidat nepřipojené atributy
	 */
	AddFreeAttributes?: boolean
	/**
	 * FreeAttributeEnabled
	 */
	FreeAttributeEnabled?: boolean
	/**
	 * MessageText
	 */
	MessageText?: string
}

export type TBulkActualizeAttributesCOMMANDParams = {
	/**
	 * Aktualizovat včetně samotné sady atributů
	 */
	ActualizeAttributeSet?: boolean
	/**
	 * MessageText
	 */
	MessageText?: string
}